'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var Email = require('./pages/main/email/email.jsx');

ReactDOM.render(<Email data={window.defaultData} />, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/client/email.entry.jsx